/**
 * App.jsx - Main application component with routing
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/Toast';
import Layout from './pages/Layout';
import PreferredShipFrom from './pages/PreferredShipFrom';
import MaterialReview from './pages/MaterialReview';
import AdminDashboard from './pages/AdminDashboard';
import Home from './pages/Home';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <AuthProvider>
        <UserProvider>
          <ToastProvider>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="preferred-ship-from" element={<PreferredShipFrom />} />
                  <Route path="material-review" element={<MaterialReview />} />
                  <Route path="admin" element={<AdminDashboard />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </ToastProvider>
        </UserProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
